import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import When from 'ui/support/When';
import useHistoryStatus from './useHistoryStatus';
import type { ColumnDef, HistoryStatusProps } from './types';
import { fundStatus, status } from '../../../repository';
import useColumns from '../../useColumns';

const HistoryStatus = (props: HistoryStatusProps) => {
    const { from } = useHistoryStatus(props);

    const { getColumnDef } = useColumns();

    const transactionStatus = from(status)('status');
    const transactionFundStatus = from(fundStatus)('fundStatus');

    const renderHistoryStatusItem = ({ field, value }: ColumnDef) => (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 1,
                whiteSpace: 'nowrap'
            }}
        >
            <Box>
                {getColumnDef(field!).headerName}:
            </Box>
            <Box
                sx={{
                    textAlign: 'right'
                }}
            >
                {value}
            </Box>
        </Box>
    );

    return (
        <When
            if={Boolean(
                transactionStatus.field ||
                transactionFundStatus.field
            )}
            then={() => (
                <Tooltip
                    arrow
                    title={(
                        <>
                            {renderHistoryStatusItem(transactionStatus)}
                            {renderHistoryStatusItem(transactionFundStatus)}
                        </>
                    )}
                    placement='top-end'
                >
                    <Box
                        component='span'
                    >
                        <GridActionsCellItem
                            onClick={event => event.stopPropagation()}
                            label='View history status'
                            icon={(
                                <VisibilityIcon />
                            )}
                        />
                    </Box>
                </Tooltip>
            )}
        />
    );
};

export default HistoryStatus;
